import { useI18n } from "vue-i18n";
import i18n from "@/plugins/i18n";

const t = i18n.global.t;

export function formatMoneyDecimal(
  number: number,
  fix = 0,
  option = "decimal",
) {
  let style: string;
  if (["USD", "RUB"].includes(option)) {
    style = "currency";
  } else if (["kilogram", "meter", "percent"].includes(option)) {
    style = "unit";
  } else {
    style = "";
  }

  const newStyle: string = style;
  const option2 = {
    newStyle, //  unit currency percent decimal
    [newStyle]: option,
    maximumFractionDigits: fix,
    minimumFractionDigits: fix,
  };
  return number ? new Intl.NumberFormat("ru-RU", option2).format(number) : "0";
}

export function convertBytes(bytes: number) {
  const sizes = [
    "measure.network.byte",
    "measure.network.kb",
    "measure.network.mb",
    "measure.network.gb",
    "measure.network.tb",
  ];

  if (bytes === 0) return `0 ${t("measure.network.byte")}`;

  const i = Number(Math.floor(Math.log(bytes) / Math.log(1024)));

  return (
    Math.round((bytes / Math.pow(1024, i)) * 100) / 100 + " " + t(sizes[i])
  );
}

export function getPercentage(value: number, total: number): string | number {
  const percentage = (value / total) * 100;
  return percentage.toFixed(1);
}

export function getTimeText(minutes: number) {
  const { t } = useI18n();
  if (minutes < 60) {
    return t("measure.date.minutes", { count: minutes });
  } else if (minutes < 3600) {
    return t("measure.date.hours", { count: Math.floor(minutes / 60) });
  } else {
    return t("measure.date.days", { count: Math.floor(minutes / 3600) });
  }
}

export function formatPhoneNumber(number: string) {
  const format = number
    ?.replace(/\D/g, "")
    .match(/(\d{0,3})(\d{0,2})(\d{0,3})(\d{0,2})(\d{0,2})/);
  return `+${format && format[1] ? format[1] : ""} ${
    format && format[2] ? format[2] : ""
  } ${format && format[3] ? format[3] : ""} ${
    format && format[4] ? format[4] : ""
  } ${format && format[5] ? format[5] : ""}`;
}

export function getAlphabeticalOrder(index: number) {
  // Check if the index is within the valid range (0 to 25 for English alphabet)
  if (index >= 0 && index <= 25) {
    // Convert ASCII code to character (A is ASCII 65)
    return String.fromCharCode(65 + index);
  } else {
    return "Index out of range";
  }
}

const timeouts: { [key: string]: ReturnType<typeof setTimeout> | undefined } =
  {};

const cTimeout = (key = "key") => {
  if (timeouts[key]) {
    clearTimeout(timeouts[key]);
    timeouts[key] = undefined;
  }
};

export const debounce = (key = "key", fn = () => {}, timeout = 500) => {
  const sTimeout = (key: string, fn: () => void, timeout: number) => {
    cTimeout(key);

    timeouts[key] = setTimeout(() => {
      try {
        fn();
      } catch (e) {
        console.log(e);
      }

      timeouts[key] = undefined;
    }, timeout);
  };

  return sTimeout(key, fn, timeout);
};

export function formatMoney(
  value: number | string,
  fractionDigits = 2,
): string {
  const number = typeof value === "string" ? parseFloat(value) : value;

  if (isNaN(number)) return "0,00";

  return number
    .toFixed(fractionDigits) // фиксируем до двух знаков после запятой
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ") // разделяем пробелами каждые 3 цифры слева от запятой
    .replace(".", ","); // заменяем точку на запятую
}

export function downloadFile(url: string, fileName: string) {
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "GET",
    })
      .then((result) => {
        return result.blob();
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        console.log(fileName);
        link.href = url;
        link.setAttribute("download", fileName);
        link.click();
        link.remove();
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export const richTextPurify = (str?: string, count = 10_000) => {
  const text = str?.replace(/<\/?[^>]+(>|$)|&[^\s]*;/gi, "");
  if (count === 0) {
    return text;
  }
  return text?.substring(0, count);
};
